// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__38w6i","detailsBorder":"styles_detailsBorder__1P8XH"};